export default function ContactSection() {
  return (
    <section
      id="contact"
      className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100"
      style={{ scrollMarginTop: '80px' }}
    >
      <div className="w-full max-w-5xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            投稿爆料
          </h2>
          <p className="mt-2 text-sm md:text-base text-foreground-600">
            有猛料？欢迎来稿，一起做大瓜的创造者
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {/* Email */}
          <div className="flex flex-col items-center text-center p-6 rounded-lg bg-background-50 border border-background-200/70">
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 mb-3">
              <i className="ri-mail-line text-primary-600 text-xl"></i>
            </div>
            <h3 className="font-heading text-base font-semibold text-foreground-900 mb-1">
              邮件投稿
            </h3>
            <p className="text-sm text-foreground-500 mb-2">
              发送爆料内容至编辑邮箱
            </p>
            <span className="text-sm font-medium text-primary-600">
              tips@jindagua.com
            </span>
          </div>

          {/* WeChat */}
          <div className="flex flex-col items-center text-center p-6 rounded-lg bg-background-50 border border-background-200/70">
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 mb-3">
              <i className="ri-wechat-line text-accent-600 text-xl"></i>
            </div>
            <h3 className="font-heading text-base font-semibold text-foreground-900 mb-1">
              微信联系
            </h3>
            <p className="text-sm text-foreground-500 mb-2">
              添加编辑微信快速沟通
            </p>
            <span className="text-sm font-medium text-foreground-600">
              公众号：今日大瓜
            </span>
          </div>

          {/* Form */}
          <div className="flex flex-col items-center text-center p-6 rounded-lg bg-background-50 border border-background-200/70">
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-secondary-100 mb-3">
              <i className="ri-chat-smile-2-line text-secondary-600 text-xl"></i>
            </div>
            <h3 className="font-heading text-base font-semibold text-foreground-900 mb-1">
              在线留言
            </h3>
            <p className="text-sm text-foreground-500 mb-2">
              直接在下方留言区告诉我们
            </p>
            <span className="text-sm font-medium text-secondary-600">
              编辑24小时内回复
            </span>
          </div>
        </div>

        {/* Quick form - display only */}
        <div className="mt-6 p-5 md:p-6 rounded-lg bg-background-50 border border-background-200/70">
          <div className="flex flex-col gap-4">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              <div>
                <label className="block text-sm text-foreground-600 mb-1">你的昵称</label>
                <div className="w-full h-10 rounded-md border border-background-300/60 bg-background-100 px-3 flex items-center text-sm text-foreground-400">
                  请输入昵称
                </div>
              </div>
              <div>
                <label className="block text-sm text-foreground-600 mb-1">联系方式</label>
                <div className="w-full h-10 rounded-md border border-background-300/60 bg-background-100 px-3 flex items-center text-sm text-foreground-400">
                  手机号或邮箱
                </div>
              </div>
            </div>
            <div>
              <label className="block text-sm text-foreground-600 mb-1">爆料内容</label>
              <div className="w-full h-24 rounded-md border border-background-300/60 bg-background-100 px-3 py-2 flex items-start text-sm text-foreground-400">
                请描述你想爆料的娱乐热点内容...
              </div>
            </div>
            <div className="flex justify-end">
              <span className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-2.5 bg-primary-500 text-background-50 text-sm font-medium rounded-md cursor-pointer">
                提交爆料
                <i className="ri-send-plane-line"></i>
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}